<template>
	<div class="baseItemBox text-white" >

        <div style="box-sizing: border-box;">
            <BlockBox title="运单数据分析"  enTitle="Waybill Data Analysis" height="380">
                <template #content>
                    <div style="padding:10px 15px 0 15px;box-sizing: border-box">
                        <div id="chartYdsj" style="height:300px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
        <div class="margin-top-15">
        	<BlockBox title="司机车辆人数" enTitle="Number of driver" height="206">
        		<template #content>
        			<!-- <div style="padding:0 15px;box-sizing: border-box">
        				<div class="text-center text-green bigNum" style="height:90px;line-height: 90px;" >
        					{{item.workerNum?item.workerNum:0}}
        				</div>
        			</div> -->
                    <div class="numBox">
                        <div class="num text-green bigNum">{{item.workerNum?item.workerNum:0}}</div>
                    </div>
        		</template>
        	</BlockBox>
        </div>
        <div class="margin-top-15"  >
            <BlockBox title="订单数据分析"  enTitle="Order Data Analysis" height="306">
                <template #content>
                    <div style="padding:5px 15px 0 15px;box-sizing: border-box">
                        <div id="chartDdsj" style="height:245px;"></div>
                    </div>
                </template>
            </BlockBox>
        </div>
 

	</div>
</template>

<script>
	import echartMixins from "@/utils/resizeMixins";
	import BlockBox from '@/views/components/blockBox2'
	// import notice from '@/assets/img/notice.png'
	// import 'swiper/swiper-bundle.min.css'
	// import Swiper from 'swiper/swiper-bundle';
	import {
		wlLeftData
	} from "@/api/api";
	export default {
		name: "cityGreenLand",
		components: {
			BlockBox
		},
		mixins: [echartMixins],
		data() {
			return {
				item: {},
				// dkList: [],
				// mrhnDay: ['12/05', '12/06', '12/07', '12/08', '12/09'],
				// 调整开始************
				// notice,
		
				// zlDataConfig: {
				// 	header: ['名称', '数量'],
				// 	indexHeader: "序号",
				// 	data: [],
				// 	index: true,
				// 	columnWidth: [60, 240]
				// },
				// mdshmxConfig: {
				// 	header: ['时间', '门店', '品类', '重量', '金额', '减碳量kg'],
				// 	indexHeader: "序号",
				// 	data: [],
				// 	index: true,
				// 	columnWidth: [70, 110, 100, 100]
				// },
				// swiperShow:false,
				timerLeft:null,
                colors: ['#f0792a', '#4b3eeb', '#247bf1', "#67e591", '#05d3f8', '#c0f02a', ],
			}
		},
		
		mounted() {
			this.changeData();
		},
		  beforeDestroy() {
		    clearTimeout(this.timerLeft);
		  },
		methods: {
           async changeData(){
                await wlLeftData().then(res => {
                    this.item=res.data
                    this.drawCddjtj()
                    this.drawDdDataFx()
                })
            },
            drawCddjtj() {
            	this.chart = this.$echarts.init(document.getElementById("chartYdsj"));
            	let data = this.item.siteTotal;
                console.log(data,'daa')
            	let dateList = [];
            	let dateValue = [];
            	data.forEach(obj => {
            		dateList.push(obj.name);
            		dateValue.push(obj.value);
            	})
            	let option = {
                    // color:['#0086ff','#00ff97','#2500ff','#ff2466'],
            	 tooltip: {
            	    trigger: 'item'
            	  },
            	  legend: {
            	    top: 'top',
            	    left: 'left',
                    textStyle: {
                        color: '#ffffff'  // 设置字体颜色为红色s
                    }
            	  },
                  grid: {
                  	left: '1%',
                  	right: '3.5%',
                  	bottom: '3%',
                  	top: 20,
                  	containLabel: true
                  },
            	  series: [
            	    {
            	      name: '运单数据',
            	      type: 'pie',
            	      radius: ['30%', '50%'],
                       center: ['43%', '70%'],
            	      avoidLabelOverlap: false,
            	      padAngle: 30,
            	      itemStyle: {
            	        borderRadius: 10
            	      },
            	      label: {
            	        show: false,
            	        position: 'center'
            	      },
            	      emphasis: {
            	        label: {
            	          show: false,
            	          fontSize: 40,
            	          fontWeight: 'bold'
            	        }
            	      },
            	      labelLine: {
            	        show: false
            	      },
            	      data:data,
                      color:this.colors
                      
            	    }
            	  ]
            	};
            	// echart图表自适应
            	this.chart.setOption(option)
            	window.addEventListener("resize", () => {
            		this.chart.resize();
            	});
            },
			drawDdDataFx() {
				this.chart = this.$echarts.init(document.getElementById("chartDdsj"));
				let data = this.item.categoryTotal;
				let dateList = [];
				let dateWeight = [];
                let dataPrice=[]
				data.forEach(obj => {
					dateList.push(obj.name);
					dateWeight.push(obj.weight);
                    dataPrice.push(obj.price)
				})
				let option = {
                    backgroundColor: 'rgba(8,18,80,0.1)',
					grid: {
						left: '3%',
						right: '3.5%',
						bottom: '3%',
						top: 20,
						containLabel: true
					},
					tooltip: {
						trigger: 'axis'
					},
					xAxis: {
						type: 'category',
			
						axisTick: {
							show: false,
						},
						data: dateList,
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.9)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.5)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#2da3ff'
							}
						}
					},
					yAxis: {
						type: 'value',
						axisTick: {
							show: false,
						},
						axisLabel: {
							textStyle: {
								color: 'rgba(255,255,255,0.9)', //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						},
						splitLine: { //网格线
							lineStyle: {
								type: 'dotted', //设置网格线类型 dotted：虚线   solid:实线
								color: ['rgba(45,163,255,0.5)']
							},
							show: true //隐藏或显示
						},
						axisLine: {
							show: false, //隐藏或显示
							lineStyle: {
								color: '#ffffff',
								fontSize: 10
							}
						}
					},
					series: [{
						name: '重量/千克',
						type: 'bar',
						barWidth: 9,
						data: dateWeight,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: {
										//数值样式
										color: 'white',
										fontSize: 12,
									},
								},
								color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
											offset: 0,
											color: 'rgba(46, 244, 167, 1)', // 0% 处的颜色
										},
										{
											offset: 1,
											color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
										}
									],
									global: false, // 缺省为 false
								}
							}
						},
			
					}, 
                    {
                    	name: '金额/万元',
                    	type: 'bar',
                    	barWidth: 9,
                    	data: dataPrice,
                    	itemStyle: {
                    		normal: {
                    			label: {
                    				show: true, //开启显示
                    				position: 'top', //在上方显示
                    				textStyle: {
                    					//数值样式
                    					color: 'white',
                    					fontSize: 12,
                    				},
                    			},
                    			color: { // 填充的颜色 // 线性渐变，前四个参数分别是 x0, y0, x2, y2, 范围从 0 - 1，相当于在图形包围盒中的百分比，如果 globalCoord 为 `true`，则该四个值是绝对的像素位置
                    				type: 'linear',
                    				x: 0,
                    				y: 0,
                    				x2: 0,
                    				y2: 1,
                    				colorStops: [{
                    						offset: 0,
                    						color: 'rgba(1, 108, 190, 1)', // 0% 处的颜色
                    					},
                    					{
                    						offset: 1,
                    						color: 'rgba(1, 38, 77, 1)' // 100% 处的颜色
                    					}
                    				],
                    				global: false, // 缺省为 false
                    			}
                    		}
                    	},
                    			
                    }, 
                    ]
				};
				// echart图表自适应
				this.chart.setOption(option)
				window.addEventListener("resize", () => {
					this.chart.resize();
				});
			}


		}
	}
</script>
<style>
	.dv-scroll-board .rows .ceil{padding:0 2px!important;}
	.dv-scroll-board .header .header-item{padding:0 2px!important;}
</style>

<style lang="scss">
    .numBox{width:75%;height:150px;padding: 12px 14px;box-sizing: border-box;
        background: url("../../assets/img/ym.png") center no-repeat;margin:0 auto;
        background-size: 100% 100%;
        .num{height: 126px;line-height:126px;text-align: center;box-shadow: 0 0 50px rgba(48, 11, 205, 0.5) inset;border-radius: 10px;}
    
    }
	.baseItemBox {
		min-height: 500px;
		padding: 14px 15px 15px 15px;
		box-sizing: border-box;

		.shtjItem {
			width: 100%;
			height: 38px;
			line-height: 38px;
			border: 1px solid #155898;
			line-height: 38px;
			padding: 0 5px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.shtjItem:hover {
			background: #155898;
		}

		.shtjBox {
			height: 200px;

			& .swiper {
				height: 200px;
			}
		}
	}
	.custlbBox{
		::v-deep .dv-scroll-board {
			.rows {
				.ceil{padding:0 5px!important;}
			}
		}
	}


	.hnzbLable {
		margin-top: 10px;
	}

	.hnzbLable .itemLable {
		line-height: 1;
		border: 1px solid;
		color: #2196f3;
		font-size: 12px;
		padding: 5px 7px;
		border-radius: 1px;
	}

	.hnzbLable .itemLable+.itemLable {
		margin-left: 7px;
	}

	.hnzbLable .itemLable.checked {
		background: #006AF6;
		color: #FFFFFF;
		border-color: #006AF6;
	}

	//调整
	.tabBox .menuBox {
		height: 32px;
		font-weight: normal;
		font-size: 12px;
	}

	.tabBox .menuBox .menuItem {
		padding: 0 12px;
		height: 20px;
		line-height: 20px;
		cursor: pointer;
	}

	.tabBox .menuBox .menuItem.checked {
		background: #2196f3;
	}

	.notcieIcon {
		width: 16px;
		height: 16px;
		display: inline-block;
		vertical-align: middle;
		margin-right: 5px;
	}
</style>